import { SVGProps } from 'react';

export const LandingPageLogo = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} width='238' height='48' viewBox='0 0 238 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_2398_11562)'>
      <mask
        id='mask0_2398_11562'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='10'
        width='238'
        height='28'
      >
        <path d='M237.913 10.4351H0V37.2238H237.913V10.4351Z' fill='white' />
      </mask>
      <g mask='url(#mask0_2398_11562)'>
        <path
          d='M143.364 28.841C145.04 27.9542 145.98 26.4384 146.647 24.7337C144.86 24.3255 143.079 24.2535 141.404 25.1403C139.732 26.027 138.792 27.5412 138.127 29.2475C139.911 29.6525 141.689 29.7277 143.364 28.841Z'
          fill='url(#paint0_radial_2398_11562)'
        />
        <path
          d='M141.005 23.2741C139.535 25.6111 137.585 26.5282 135.86 27.0437C135.573 25.2637 135.556 23.1108 137.027 20.7739C138.495 18.4369 140.444 17.5197 142.17 17.0059C142.455 18.7826 142.471 20.9387 141.005 23.2757V23.2741Z'
          fill='url(#paint1_radial_2398_11562)'
        />
        <path
          d='M135.302 19.2819C135.355 15.9462 133.759 13.4315 132.715 12.0293C131.567 13.4795 129.951 15.8773 129.895 19.1955C129.846 22.2704 131.177 24.7066 132.48 26.4497C133.836 24.7241 135.251 22.3664 135.302 19.2836V19.2819Z'
          fill='url(#paint2_radial_2398_11562)'
        />
        <path
          d='M127.16 17.3915C125.146 13.6588 121.897 11.6387 119.771 10.4351C119.661 12.9385 119.472 16.6201 121.528 20.4296C123.4 23.8982 126.24 25.8174 128.915 27.3845C129.122 24.3016 128.993 20.7897 127.16 17.3915Z'
          fill='url(#paint3_radial_2398_11562)'
        />
        <path
          d='M117.089 20.0537C112.441 17.4238 107.132 16.8219 103.649 16.8635C105.325 19.7527 108.553 24.0506 113.308 26.7397C117.882 29.328 123.057 29.9714 126.746 29.9298C124.796 26.6677 121.669 22.6468 117.089 20.0537Z'
          fill='url(#paint4_radial_2398_11562)'
        />
        <path
          d='M108.279 29.0076C102.496 29.0076 96.0323 30.7251 90.8701 33.1149C96.1123 35.4935 102.334 37.2238 108.279 37.2238C113.015 37.2238 118.677 36.3018 125.686 33.1149C118.019 29.6687 112.703 29.0076 108.279 29.0076Z'
          fill='url(#paint5_radial_2398_11562)'
        />
        <path
          d='M65.0798 18.075C61.5231 18.075 59.8536 20.7129 59.8536 23.9767C59.8536 27.4661 62.0193 29.8335 65.5024 29.8335C67.8601 29.8335 69.2863 28.9131 69.48 28.8138L68.5549 26.7186C68.4044 26.821 67.4023 27.4917 65.8449 27.4917C64.0489 27.4917 62.8773 26.4304 62.762 24.9467H70.0339C70.069 24.737 70.1955 24.0646 70.1955 23.4612C70.1939 20.3303 68.3291 18.075 65.0814 18.075H65.0798ZM62.7604 22.8257C62.7748 21.558 63.4696 20.3047 65.0798 20.3047C66.5876 20.3047 67.3783 21.406 67.4023 22.8257H62.7604ZM171.616 22.5345C170.938 21.8109 169.542 20.7048 167.8 21.1627C164.21 22.1071 162.046 30.2416 168.27 30.2416C168.607 30.2416 170.919 30.2256 171.302 30.2256C170.932 31.7174 168.222 32.8427 163.831 32.8427C158.469 32.8427 155.895 29.062 159.165 23.6197L157.015 22.5345C154.288 27.1444 153.706 35.5574 163.831 35.5574C171.026 35.5574 174.015 32.7963 174.015 28.6249C174.015 25.3853 172.894 23.9014 171.616 22.5328V22.5345ZM168.91 27.5781C165.817 27.5781 165.875 24.3656 168.033 23.9494C168.88 23.7861 170.531 24.6761 171.302 27.5781H168.91ZM16.1122 21.971V29.5806H13.4071V22.512C13.4071 21.2507 12.7557 20.4392 11.4256 20.4392C10.4347 20.4392 9.47913 20.945 9.34467 21.0186C9.36709 21.1338 9.51115 21.7325 9.51115 22.7378V29.5821H6.80442V22.4928C6.80442 21.2315 6.11134 20.4392 4.82921 20.4392C3.83519 20.4392 2.93082 20.8697 2.81877 20.9242C2.83318 20.9898 2.91161 21.3628 2.91161 22.0174V29.5806H0.211288V20.6697C0.211288 20.0246 0.0400166 19.3427 0 19.2259C0.281717 19.1187 2.9004 18.075 5.09651 18.075C7.41587 18.075 8.25783 19.0626 8.38268 19.1811C8.56835 19.069 10.121 18.075 11.8945 18.075C14.4268 18.075 16.1139 19.514 16.1139 21.971H16.1122ZM193.746 17.9437L191.926 16.1094L193.721 14.2206L195.479 15.9733L197.256 14.1885L199.137 16.0165L197.306 17.9437L195.478 16.1558L193.745 17.9437H193.746ZM237.913 30.2433H235.206V13.8492L237.913 13.2186V30.2448V30.2433ZM195.484 14.9361L193.662 13.1129L195.462 11.2097L197.306 13.0617L195.484 14.9376V14.9361ZM166.571 17.9437L164.752 16.1205L166.545 14.2142L168.308 15.9798L170.082 14.1982L171.959 16.0261L170.136 17.9469L168.308 16.159L166.571 17.9454V17.9437ZM38.1214 26.3024C38.1214 28.7754 35.9861 29.8303 33.6411 29.8303C31.7235 29.8303 30.1197 29.1628 29.9212 29.0875L30.712 26.9715C30.7663 27.0019 31.9573 27.6453 33.1689 27.6453C34.4735 27.6453 35.1249 27.1043 35.1249 26.3649C35.1249 25.8302 34.7744 25.3692 33.8572 25.0026C33.5515 24.8811 33.0633 24.6905 32.7271 24.564C31.5619 24.1287 30.2157 23.3268 30.2157 21.4412C30.2157 19.2099 32.2758 18.0798 34.3215 18.0718C36.1622 18.0606 37.3339 18.6208 37.6237 18.7505L36.8617 20.8409C36.7784 20.8058 35.6452 20.3255 34.3919 20.3255C33.6363 20.3255 32.9833 20.6184 32.9833 21.2939C32.9833 21.9166 33.4346 22.2464 34.2558 22.5681C34.5791 22.6961 35.0401 22.869 35.4003 23.013C36.8537 23.5877 38.1214 24.4984 38.1214 26.2992V26.3024ZM232.282 27.4421V13.2186L229.576 13.8492V24.7145C229.576 26.3584 229.796 27.0019 229.831 27.1636C229.741 27.2004 228.965 27.5845 227.473 27.5845H222.089C222.173 27.4437 222.388 26.2208 221.501 24.6425C220.058 22.0894 219.229 19.991 217.163 19.991C214.618 19.991 213.56 22.4736 211.779 25.43C211.291 26.2367 210.799 27.5814 208.73 27.5814H204.32C204.258 27.4725 204.042 27.1603 204.042 26.6338C204.042 23.1827 202.675 21.1579 201.251 20.0726L199.408 21.9069C200.817 22.9314 201.437 24.0919 201.437 26.2496C201.437 27.202 201.623 27.4165 201.716 27.5814H198.571C198.467 27.3716 198.337 27.0436 198.337 26.3712C198.337 23.6325 196.827 22.3744 195.878 21.6092L194.084 23.4404C194.41 23.6821 195.822 24.4569 195.822 26.272C195.822 27.1444 195.985 27.4581 196.039 27.5814H193.083C193.006 27.4213 192.859 27.0403 192.859 26.3712C192.859 23.6325 191.341 22.3744 190.4 21.6092L188.599 23.4404C188.949 23.7237 190.343 24.5801 190.343 26.3904C190.343 26.9843 190.479 27.4725 190.561 27.5829H183.586C183.41 25.2652 182.249 23.41 180.915 22.4656L179.023 24.372C180.212 25.6446 180.856 27.0787 180.856 29.1052C180.856 32.1849 178.931 34.0977 175.537 34.6659L175.774 36.4474C181.112 36.1128 183.401 33.134 183.562 30.2433H209.423C211.371 30.2433 212.267 29.2044 212.498 28.8011C212.747 29.0796 213.773 30.2433 216.513 30.2433H227.343C230.352 30.2433 232.413 29.3917 232.571 29.3261C232.541 29.2076 232.282 28.4937 232.282 27.4405V27.4421ZM218.539 27.5829H217.431C215.235 27.5829 214.436 26.6834 213.979 26.2319C215.238 24.0022 215.683 22.9314 216.786 22.9314C217.729 22.9314 218.078 23.911 219.202 25.9503C219.725 26.8851 219.226 27.5829 218.539 27.5829ZM77.8579 18.075C74.1684 18.075 71.7993 20.4872 71.7993 23.9302C71.7993 27.3733 74.3188 29.8318 77.36 29.8318C78.0371 29.8318 78.7367 29.6942 79.4298 29.4493V34.6515L82.1365 34.3153V20.8889C82.1365 20.119 82.2165 19.1266 82.2725 18.8834C82.0052 18.7809 79.8923 18.075 77.8594 18.075H77.8579ZM79.4313 22.1151V27.1732C78.9799 27.3749 78.4421 27.4901 77.9491 27.4901C75.9418 27.4901 74.8182 25.8286 74.8182 23.951C74.8182 22.0735 75.6714 20.42 77.789 20.42C78.7991 20.42 79.4329 20.6729 79.5402 20.7129C79.521 20.8089 79.4329 21.4124 79.4329 22.1151H79.4313ZM50.0784 22.0606V29.5806H47.3716V22.5585C47.3716 21.2187 46.6065 20.42 45.2908 20.42C44.2903 20.42 43.2755 20.9898 42.8898 21.2491V29.579H40.1862V13.1834L42.8898 12.5495V18.9554C43.0291 18.8769 44.3064 18.0734 46.0511 18.0734C48.6537 18.075 50.0784 19.61 50.0784 22.0622V22.0606ZM27.7827 22.1887C27.7827 19.5156 26.1357 18.0734 23.3504 18.0734C21.2856 18.0734 19.3376 18.9506 19.1311 19.0434L20.0515 21.0923C20.1956 21.0315 21.6378 20.3672 23.1904 20.3672C24.3381 20.3672 25.0808 20.801 25.0808 21.4124C25.0808 22.067 24.4358 22.3263 23.4594 22.5585C21.3944 23.037 18.0955 23.274 18.0955 26.3376C18.0955 28.9723 20.7046 29.8335 23.1424 29.8335C25.5802 29.8335 27.8211 29.0092 27.9844 28.9579C27.9347 28.7595 27.7843 28.2825 27.7843 27.1267V22.1903H27.7827V22.1887ZM23.1055 27.615C22.0635 27.615 21.0712 27.2372 21.0712 26.2031C21.0712 25.3613 21.9739 25.0299 22.9535 24.8026C23.7778 24.6074 24.6951 24.3672 25.0792 24.0646V25.987C25.0792 26.7426 25.1496 27.1684 25.1688 27.2676C25.068 27.3012 24.2005 27.6165 23.1055 27.6165V27.615ZM57.5855 18.0734C58.2786 18.0734 59.0517 18.1663 59.6551 18.3199L58.8404 20.6392C58.4818 20.5352 57.8496 20.42 57.3502 20.42C56.2569 20.42 55.3286 20.6904 55.2229 20.7257C55.2389 20.7993 55.3493 21.3083 55.3493 22.2656V29.5806H52.6522V21.5261C52.6522 20.2391 52.4586 19.3907 52.4442 19.3123C52.7467 19.197 55.1669 18.0734 57.5855 18.0734Z'
          fill='url(#paint6_radial_2398_11562)'
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(138.749 29.3406) scale(10.1413 10.1413)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.21' stopColor='#F8B00D' />
        <stop offset='0.46' stopColor='#F08218' />
        <stop offset='0.69' stopColor='#EB6020' />
        <stop offset='0.88' stopColor='#E84B25' />
        <stop offset='1' stopColor='#E74427' />
      </radialGradient>
      <radialGradient
        id='paint1_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(136.471 27.1258) scale(11.9123 11.9123)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.21' stopColor='#F8B00D' />
        <stop offset='0.46' stopColor='#F08218' />
        <stop offset='0.69' stopColor='#EB6020' />
        <stop offset='0.88' stopColor='#E84B25' />
        <stop offset='1' stopColor='#E74427' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(133.078 26.5297) scale(14.9037 14.9038)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.21' stopColor='#F8B00D' />
        <stop offset='0.46' stopColor='#F08218' />
        <stop offset='0.69' stopColor='#EB6020' />
        <stop offset='0.88' stopColor='#E84B25' />
        <stop offset='1' stopColor='#E74427' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(129.496 27.4708) scale(19.2818 19.2818)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.21' stopColor='#F8B00D' />
        <stop offset='0.46' stopColor='#F08218' />
        <stop offset='0.69' stopColor='#EB6020' />
        <stop offset='0.88' stopColor='#E84B25' />
        <stop offset='1' stopColor='#E74427' />
      </radialGradient>
      <radialGradient
        id='paint4_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(127.824 30.1903) scale(27.8326 27.8326)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.2' stopColor='#F8B00D' />
        <stop offset='0.44' stopColor='#F08218' />
        <stop offset='0.65' stopColor='#EB6020' />
        <stop offset='0.83' stopColor='#E84B25' />
        <stop offset='0.94' stopColor='#E74427' />
      </radialGradient>
      <radialGradient
        id='paint5_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(126.899 33.1886) scale(35.8734 35.8734)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.18' stopColor='#F8B00D' />
        <stop offset='0.4' stopColor='#F08218' />
        <stop offset='0.6' stopColor='#EB6020' />
        <stop offset='0.76' stopColor='#E84B25' />
        <stop offset='0.87' stopColor='#E74427' />
      </radialGradient>
      <radialGradient
        id='paint6_radial_2398_11562'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(164.014 -27.4518) rotate(-119.9) scale(131.816 172.679)'
      >
        <stop stopColor='#FFDC04' />
        <stop offset='0.18' stopColor='#F8B00D' />
        <stop offset='0.4' stopColor='#F08218' />
        <stop offset='0.6' stopColor='#EB6020' />
        <stop offset='0.76' stopColor='#E84B25' />
        <stop offset='0.87' stopColor='#E74427' />
      </radialGradient>
      <clipPath id='clip0_2398_11562'>
        <rect width='237.913' height='48' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
